import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // إذا كان هناك hash في الرابط، لا نقوم بالتمرير إلى أعلى
    if (hash) {
      return;
    }

    // دالة للتمرير إلى أعلى الصفحة
    const scrollToTop = () => {
      // محاولة التمرير السلس أولاً
      try {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      } catch (error) {
        // إذا فشل التمرير السلس، استخدم التمرير الفوري
        window.scrollTo(0, 0);
      }
    };

    // دالة بديلة للتمرير
    const alternativeScrollToTop = () => {
      // محاولة استخدام document.documentElement
      if (document.documentElement && document.documentElement.scrollTop !== undefined) {
        document.documentElement.scrollTop = 0;
      }
      
      // محاولة استخدام document.body
      if (document.body && document.body.scrollTop !== undefined) {
        document.body.scrollTop = 0;
      }
      
      // محاولة استخدام window.scrollTo
      if (window.scrollTo) {
        window.scrollTo(0, 0);
      }
    };

    // دالة للتمرير الفوري
    const immediateScrollToTop = () => {
      // استخدام جميع الطرق المتاحة
      alternativeScrollToTop();
      
      // محاولة إضافية باستخدام scrollIntoView
      if (document.body && document.body.scrollIntoView) {
        document.body.scrollIntoView({ behavior: 'auto', block: 'start' });
      }
    };

    // التمرير الفوري
    immediateScrollToTop();
    
    // التمرير بعد فترة قصيرة
    const timer1 = setTimeout(scrollToTop, 50);
    
    // التمرير باستخدام requestAnimationFrame
    const timer2 = setTimeout(() => {
      requestAnimationFrame(() => {
        alternativeScrollToTop();
      });
    }, 100);
    
    // التأكد من التمرير
    const timer3 = setTimeout(() => {
      if (window.pageYOffset > 0 || (document.documentElement && document.documentElement.scrollTop > 0)) {
        immediateScrollToTop();
      }
    }, 200);

    // محاولة إضافية بعد فترة أطول
    const timer4 = setTimeout(() => {
      immediateScrollToTop();
    }, 500);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
      clearTimeout(timer4);
    };
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop; 